import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePromise } from "../../Utils/usePromise";
import axios from "axios";
import { match, P } from "ts-pattern";
import { Box, Image, LoadingOverlay } from "@mantine/core";
import { parseApiError } from "@yooink/youtils/es/ParseApiError";
import { Alert } from "reactstrap";
import Button from "reactstrap/es/Button";
import { Block } from "@yooink/youi/dist/Layout/Block";
import { Header } from "@yooink/youi/dist/Layout/Header";
import MenuManager from "@yooink/youtils/es/MenuManager";
import { FaUpload } from "react-icons/fa";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import { useState } from "react";
import { toast } from "react-toastify";
import { GrUpdate } from "react-icons/gr";
import { CompactBadgeUser } from '../../Components/User/Badges/BadgeUser';
import { format } from "date-fns/esm";
import ru from "date-fns/locale/ru";
import { useSmartBadgeControls } from "../../Components/BaidgeManager";
import { errorRenderer } from "./errorRenderer";
MenuManager.RegisterItem({
    key: 'moderationFiles',
    path: '/uploadModeration',
    name: 'Модерация загрузок',
    icon: _jsx(FaUpload, {}),
    acl: 'users',
    position: -1
});
function RenderContent({ item, onHide }) {
    const [isLoading, setLoading] = useState(false);
    function accept() {
        setLoading(true);
        return axios.post(`/api/v2/files/moderation/${item._id}/setStatus`, {
            status: 'OK'
        }).then(onHide).catch(err => {
            toast.error(parseApiError(err));
            setLoading(false);
        });
    }
    function reject() {
        setLoading(true);
        return axios.post(`/api/v2/files/moderation/${item._id}/setStatus`, {
            status: 'FAIL'
        }).then(onHide).catch(err => {
            toast.error(parseApiError(err));
            setLoading(false);
        });
    }
    return (_jsxs(Box, Object.assign({ pos: "relative" }, { children: [_jsx(LoadingOverlay, { visible: isLoading }), _jsxs(Row, { children: [_jsx(Col, Object.assign({ lg: 6 }, { children: _jsx(Image, { src: item.url, fit: 'contain', width: '600px' }) })), _jsxs(Col, Object.assign({ lg: 6 }, { children: [item.user && _jsx(CompactBadgeUser, Object.assign({}, item.user)), _jsxs("p", { children: ["\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E: ", format(new Date(item.createdAt), 'dd MMMM yyyy HH:mm', { locale: ru })] }), _jsx("p", { children: item.systemComment }), _jsxs(Row, Object.assign({ form: true }, { children: [_jsx(Col, { children: _jsx(Button, Object.assign({ block: true, color: 'success', onClick: accept }, { children: "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C" })) }), _jsx(Col, { children: _jsx(Button, Object.assign({ block: true, color: 'danger', onClick: reject }, { children: "\u041A\u0440\u0430\u043C\u043E\u043B\u0430" })) })] }))] }))] })] })));
}
function renderContent({ data: items, setData }) {
    const badgeControls = useSmartBadgeControls('moderationFiles');
    if (!items.length)
        return _jsx(Alert, Object.assign({ color: 'info' }, { children: "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0442\u044C \u043D\u0435\u0447\u0435\u0433\u043E" }));
    return items.map((item, _index) => (_jsx(RenderContent, { item: item, onHide: () => {
            setData(arr => {
                const _arr = arr.slice();
                _arr.splice(_index, 1);
                return _arr;
            });
            badgeControls.dec();
        } }, item._id)));
}
export function ImageModerationPage() {
    const data = usePromise(() => axios.get('/api/v2/files/moderation').then(res => res.data.items), []);
    return (_jsxs(Block, { children: [_jsx(Header, Object.assign({ title: 'Модерация пользовательских загрузок' }, { children: _jsx(GrUpdate, { onClick: data.run }) })), match(data)
                .with({ isLoading: true }, () => _jsx(LoadingOverlay, { visible: true }))
                .with({ isError: true }, errorRenderer)
                .with({ data: P.array(P.any) }, renderContent)
                .otherwise(errorRenderer)] }));
}
